module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9Xcdk"))).then(() => parcelRequire('d0iPb'));